import { render, staticRenderFns } from "./Jessibuca.vue?vue&type=template&id=47854f2f&scoped=true"
import script from "./Jessibuca.vue?vue&type=script&lang=js"
export * from "./Jessibuca.vue?vue&type=script&lang=js"
import style0 from "./Jessibuca.vue?vue&type=style&index=0&id=47854f2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47854f2f",
  null
  
)

export default component.exports